import axiosInstance from './axios';
import { BonusesParams, BonusesResponse } from 'types/bonus';

export const bonusService = {
  getBonuses: async (params: BonusesParams): Promise<any> => {
    const { siteId } = params;
    const response = await axiosInstance.get(`/admin/level/bonus-definitions`, {
      params: {
        siteId,
      },
    });
    return response.data;
  },
  createBonus: async (data: any): Promise<any> => {
    const response = await axiosInstance.post(`/admin/bonuses`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },
  deleteBonus: async (id: string): Promise<any> => {
    const response = await axiosInstance.delete(`/admin/bonuses/${id}`);
    return response.data;
  },
  updateBonus: async (id: string | number, data: any): Promise<any> => {
    const response = await axiosInstance.put(`/admin/level/bonus-definitions`, data);
    return response.data;
  },
  updateBonusImage: async (
    image: File,
    siteId: string | number,
    bonusType: string,
  ): Promise<any> => {
    const formData = new FormData();
    formData.append('image', image);
    formData.append('siteId', String(siteId));
    formData.append('bonusType', bonusType);
    const response = await axiosInstance.patch(`/admin/level/bonus-definitions/image`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },
  toggleBonusStatus: async (id: string | number, isEnabled: boolean): Promise<any> => {
    const response = await axiosInstance.patch(`/admin/level/bonus-definitions/${id}/toggle`, {
      isEnabled,
    });
    return response.data;
  },
  getLevelBonusSettings: async (siteId: string | number): Promise<any> => {
    const response = await axiosInstance.get(`/admin/level/level-bonus-settings`, {
      params: { siteId },
    });
    return response.data;
  },
  toggleLevelBonusSetting: async (id: string | number, isEnabled: boolean): Promise<any> => {
    const response = await axiosInstance.patch(`/admin/level/level-bonus-settings/${id}/toggle`, {
      isEnabled,
    });
    return response.data;
  },
  updateLevelBonusSetting: async (data: any): Promise<any> => {
    const response = await axiosInstance.put(`/admin/level/level-bonus-settings`, data);
    return response.data;
  },
  getUserBonuses: async (userId: string | number, params?: any): Promise<any> => {
    const response = await axiosInstance.get(`/admin/users/${userId}/bonuses`, { params });
    return response.data;
  },
  giveUserBonus: async (
    userId: string | number,
    data: { bonusType: string; amount: string; currencyCode: string; reason?: string },
  ): Promise<any> => {
    const response = await axiosInstance.post(`/admin/users/${userId}/bonuses/grant`, data);
    return response.data;
  },
  reorderBonuses: async (data: { ids: number[] }): Promise<any> => {
    const response = await axiosInstance.patch(`/admin/level/bonus-definitions/order`, data);
    return response.data;
  },
};
